const CHUNK_RELOAD_KEY = 'chunk-reload-attempted'

export const isChunkLoadError = (error) => {
    const message = (error && (error.message || error.reason)) || (typeof error === 'string' ? error : '')
    return error?.name === 'ChunkLoadError'
        || /Loading( CSS)? chunk [\w.-]+ failed/i.test(message)
        || /Unexpected token '<'/i.test(message)
}

export const hasAlreadyAttemptedChunkReload = () => !!sessionStorage.getItem(CHUNK_RELOAD_KEY)

// Le flag n'est JAMAIS effacé manuellement : il vit pour toute la durée de l'onglet
// (sessionStorage se vide tout seul à la fermeture), garantissant au maximum un seul
// rechargement automatique par onglet, à vie — sinon un chunk cassé de façon permanente
// provoquerait une boucle de rechargement infinie.

// Retourne true si un rechargement a été déclenché
export const attemptChunkReload = () => {
    if (hasAlreadyAttemptedChunkReload()) return false
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
    window.location.reload()
    return true
}
